import { useTheme } from "@material-ui/core";
export function useThemeComponent(type) {
    const theme = useTheme();
    const tenantComponents = theme.components;
    const tenantComponent = tenantComponents?.[type];
    return tenantComponent;
}
//# sourceMappingURL=useTenantComponent.js.map